<template>
    <div
        v-if="showHotkeysVisualizer"
        id="hotkeys-visualizer"
        class="absolute bg-base-200 border-base-100 dark:border-2 flex flex-col gap-y-6 items-start shadow-2xl p-4 ml-0.5 rounded bottom-8 left-8 w-fit"
        @mouseenter="pauseTimers"
        @mouseleave="resumeTimers"
    >
        <div
            v-if="nextSuggestedHotkeysSequence && nextSuggestedHotkeysSequence.length > 1"
            class="grid gap-x-5 gap-y-4 text-md grid-cols-3"
        >
            <div
                v-for="(suggestion, index) in nextSuggestedHotkeysSequence"
                :key="index"
                class="flex items-center gap-x-1"
            >
                <span class="font-semibold">{{ suggestion.key }}</span>
                <i class="i-ph-arrow-right text-xs"/>
                <span>{{ getKeySuggestionLabel(suggestion.key) }}</span>
            </div>
        </div>
        <div
            v-if="nextSuggestedHotkeysSequence && nextSuggestedHotkeysSequence.length === 1"
            class="grid gap-x-5 gap-y-4 text-md grid-cols-4"
        >
            <div
                v-for="(suggestion, sIndex) in nextSuggestedHotkeysSequence[0].nextKeys"
                :key="sIndex"
                class="flex items-center gap-x-1"
            >
                <span class="font-semibold">{{ suggestion }}</span>
                <i class="i-ph-arrow-right text-xs"/>
                <span>{{ getKeySuggestionLabel(suggestion, nextSuggestedHotkeysSequence[0].key) }}</span>
            </div>
        </div>
        <div v-if="lastThreePushedKeys && nextSuggestedHotkeysSequence && nextSuggestedHotkeysSequence.length === 0">
            Ingen treff
        </div>

        <div class="flex flex-col space-y-2 w-full">
            <div class="flex gap-2">
                <div v-for="(pushedKey, index) in lastThreePushedKeys" :key="index"><kbd class="kbd bg-base-100 font-semibold">{{ pushedKey }}</kbd></div>
            </div>
            <div class="self-center">
                <span class="font-semibold">&lt;esc&gt;</span> for å starte på nytt
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import {useHotkeys} from '@/hotkeys/useHotkeys'
import {useFavoriteLayouts} from '@/favourites/favourites.service'
import {featureHotkeys} from '@/hotkeys/navigationHotkeys'

const {lastThreePushedKeys, pauseTimers, resumeTimers, showHotkeysVisualizer, nextSuggestedHotkeysSequence} = useHotkeys()
const {layouts} = useFavoriteLayouts()

const getKeySuggestionLabel = (key: string, mainKey?: string) => {
    if (mainKey === 'f') {
        return layouts.find(layout => layout.layoutId === key)?.name
    }

    if (['1', '2', '3', '4'].includes(key)) {
        return 'Panel ' + key
    }

    if (key === 'f') {
        return 'Favoritter'
    }

    return featureHotkeys.value.find((keys) => keys.key === key)?.route.componentName || ''
}

</script>

<style scoped>
</style>